import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dashboardfilter',
  pure: false
})
export class DashboardfilterPipe implements PipeTransform {

  transform(items: any[], searchString: string): any {
    if (!items || !searchString) {
        return items;
    }
    if(searchString) {
      searchString = searchString.toLowerCase();
    }
    console.log('searchString', searchString);
    console.log('items', items);
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
     let returned = items.filter((item) => {
      return ((item.UniversityFullName && item.UniversityFullName.toLowerCase().indexOf(searchString) !== -1) || 
      (item.InternalUniversityCode && item.InternalUniversityCode.toLowerCase().indexOf(searchString) !== -1))
     });
    console.log('returned', returned);
     return returned;
    }

}
